<!-- eslint-disable @intlify/vue-i18n/no-raw-text -->
<template>
  <div
    class="flex w-[490px] flex-col border-t-1 border-border-default"
    :class="isCloud ? 'border-b-1' : ''"
  >
    <div class="flex h-full w-full flex-col gap-4 p-4">
      <!-- Description -->
      <div class="flex flex-col gap-2 items-center">
        <p class="text-left text-sm whitespace-pre-line">
          <span v-for="item in description" :key="item" class="leading-6">
            {{ item }} <br
          /></span>
        </p>
        <img src="@/assets/images/wx_group.png" alt="WX Group" class="w-30" />
        <p class="w-full text-left text-sm whitespace-pre-line mb-0">
          PS 加载失败的节点会显示为红色。<br />
          读取节点树时未找到以下节点:
        </p>
      </div>

      <MissingCoreNodesMessage v-if="!isCloud" :missing-core-nodes />

      <!-- Missing Nodes List Wrapper -->
      <div
        class="comfy-missing-nodes flex flex-col max-h-[256px] rounded-lg py-2 scrollbar-custom bg-secondary-background"
      >
        <div
          v-for="(node, i) in uniqueNodes"
          :key="i"
          class="flex min-h-8 items-center justify-between px-4 py-2 bg-secondary-background text-muted-foreground"
        >
          <span class="text-xs">
            {{ node.label }}
          </span>
          <span v-if="node.hint" class="text-xs">{{ node.hint }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { isCloud } from '@/platform/distribution/types'
import type { MissingNodeType } from '@/types/comfy'
import { useMissingNodes } from '@/workbench/extensions/manager/composables/nodePack/useMissingNodes'

const props = defineProps<{
  missingNodeTypes: MissingNodeType[]
}>()

// Get missing core nodes for OSS mode
const { missingCoreNodes } = useMissingNodes()

const description = [
  '1、Runnode已收到并记录节点的缺失，我们会尽快为你增加对应的节点;',
  '2、你可以前往Runnode工作流商城，查看其他创作者分享的工作流，尝试使用其他同功能类型的节点进行替换;',
  '3、欢迎加入Runnode工作流社区 (WX群号:二维码)与其他工作流爱好者一起交流经验与解决方案。'
]

const uniqueNodes = computed(() => {
  const seenTypes = new Set()
  return props.missingNodeTypes
    .filter((node) => {
      const type = typeof node === 'object' ? node.type : node
      if (seenTypes.has(type)) return false
      seenTypes.add(type)
      return true
    })
    .map((node) => {
      if (typeof node === 'object') {
        return {
          label: node.type,
          hint: node.hint,
          action: node.action
        }
      }
      return { label: node }
    })
})
</script>
